export default "__VITE_ASSET__nbhshgH8__"